import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Menu, Close } from "@mui/icons-material";
import { Box, Grid, IconButton } from "@mui/material";
import { NavLink, Outlet } from "react-router-dom";

import "../dashboard.scss";
import Header from "../../../components/Header";
import Sidebar from "../../../components/Sidebar";
import { isAdmin } from "../../../utils/helpers";
import { getClientDetail } from "../../../sevices/clientApi";

function Dashboard() {
  const isMobile = useMediaQuery({ maxWidth: "960px" });
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    
    // Check if user is a client (not admin)
    if (userData && !isAdmin()) {
      // Call clientDetail API with role_id
      fetchClientDetails(userData.role_id);
    }
  }, []);

  const fetchClientDetails = async (roleId) => {
    getClientDetail(roleId).then((res) => {
      if (res.data) {
        localStorage.setItem("isSelfService", res.data.data.response_data.is_self_service || false);
      }
    }).catch((err) => {
      console.error("Error fetching client details:", err);
    }); 
  };

  return (
    <Box className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {/* Header */}
      <Header />
      
      {/* Sidebar */}
      <Box className={`sidebar-wrapper ${sidebarOpen ? 'open' : ''}`}>
        <Sidebar />
      </Box>
      
      {/* Mobile sidebar toggle */}
      {isMobile && (
        <IconButton 
          className="sidebar-toggle"
          onClick={toggleSidebar}
          sx={{ position: 'fixed', left: sidebarOpen ? '240px' : '10px', top: '10px', zIndex: 1300 }}
        >
          {sidebarOpen ? <Close /> : <Menu />}
        </IconButton>
      )}
      
      {/* Main content */}
      <Box 
        className="main-content"
        sx={{ 
          marginLeft: isMobile ? 0 : (sidebarOpen ? '240px' : 0),
          width: isMobile ? '100%' : (sidebarOpen ? 'calc(100% - 240px)' : '100%'),
          transition: 'all 0.3s ease'
        }}
      >
        <Box className="wrapper_dashboard">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div className="main-container">
                <Outlet />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default Dashboard;
